import {createAction} from "@reduxjs/toolkit";

export const setUIPipelineFilter = createAction<{
  id: string,
  fromDttm: number,
  toDttm?: number
}>("ots-ui/pipeline/setFilter");
